module.exports = __webpack_public_path__ + "static/media/partialpay.fb763b7e.svg";